import { Link as Linkto } from "react-router-dom";
import moment from 'moment';
import styles from '../reschedule/reschedule.module.css';
import React from "react";
import { Helmet } from "react-helmet";
import { Background, Parallax } from "react-parallax";

const ProspectVerificationInvalid = ({ history, match }) => {
    const propertyDetails = null;

    return (<React.Fragment>
        <Helmet title="Verification Invalid Link" />

        <Parallax strength={300} className="RentalParallax">
            <Background className="custom-bg">
                <img src="/static/img/rental-app-bg.jpg" alt="fill murray" />
            </Background>
        </Parallax>

        <div className="WhiteBG">

            <div className={`${styles.RentalAppliArea}`}>

                {/* <div className={`${styles.RentalAppliHead}`}>
                    <img src={'/static/img/logo.svg'} alt="logo" style={{ width: '200px' }} />
                    <p className={`${styles.RentalAppliHeadTitle}`}>Reschedule Invalid</p>
                </div> */}

                <div className={`${styles.RescheduleMessageSec}`}>
                    <img src="/static/img/reschedule-invalid.png" alt="" />
                    <p className={`${styles.MessageTitle}`}>Invalid Link</p>
                    <p className={`${styles.MessageText}`}>The link you entered may be incorrect or the page may no longer exist.</p>
                </div>


            </div>

            <div className={`${styles.FooterWrap}`}>
                <div className={`${styles.footerMain}`}>

                    <div className={`${styles.footerMainLeft}`}>
                        <Linkto to={'/'}><img src={'/static/img/logo.svg'} alt="logo" /></Linkto>
                    </div>

                    <div className={`${styles.footerMainRight}`}>
                        <div>
                            <h3>CONTACT US</h3>
                            <ul>
                                <li><a href={`mailto: hello@propertydek.com`}>hello@propertydek.com</a></li>
                                <li><a href={`tel: 1-718-825-4746`} >1-718-825-4746</a></li>
                            </ul>
                        </div>
                        <div>
                            <h3>FIND US</h3>
                            <ul>
                                <li>{propertyDetails?.address} <br />{propertyDetails?.city}, {propertyDetails?.state} {propertyDetails?.zip}</li>
                            </ul>
                        </div>
                        <div>
                            <h3>LEGAL</h3>
                            <ul>
                                <li><Linkto to={'/privacy-policy'}>Privacy Policy</Linkto></li>
                                <li><Linkto to={'/eula'}>End User License Agreement</Linkto></li>
                            </ul>
                        </div>
                        <div>
                            <ul>
                                <li>PropertyDek © {moment().format("YYYY")}.<br />All rights reserved.</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </React.Fragment>)
}

export default ProspectVerificationInvalid;